import { IStackTokens } from "@fluentui/react";
import { makeStyles, shorthands } from "@fluentui/react-components";
import { designTokens } from "../../theme/customTheme";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[3],
    paddingBottom: designTokens.spacing[4],
    paddingLeft: designTokens.spacing[3],
    paddingRight: designTokens.spacing[3],
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
    overflowX: "auto",
  },
  miniContainer: {
    marginTop: designTokens.spacing[4],
    backgroundColor: designTokens.neutral.white,
    ...shorthands.padding(designTokens.spacing[5]),
    ...shorthands.borderRadius(designTokens.borderRadius.lg),
    ...shorthands.border("1px", "solid", designTokens.neutral[200]),
    boxShadow: designTokens.shadow.sm,
  },
  selectPeriodDropdown: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[3],
    alignItems: "flex-start",
  },
  cardContainer: {
    display: "flex",
    gap: designTokens.spacing[4],
    width: "100%",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    boxSizing: "border-box",
  },
  card: {
    minWidth: "280px",
    // maxWidth: "320px",
    flex: "1 1 100px 800px",
    ...shorthands.padding(designTokens.spacing[4], designTokens.spacing[5]),
    ...shorthands.borderRadius(designTokens.borderRadius.lg),
    backgroundColor: designTokens.neutral.white,
    ...shorthands.border("1px", "solid", designTokens.neutral[200]),
    boxShadow: designTokens.shadow.sm,
    transition: `all ${designTokens.transition.base}`,
    flexShrink: 0,
    overflowY: "auto",
  },
  cardContent: {
    paddingTop: designTokens.spacing[3],
    paddingBottom: designTokens.spacing[2],
  },
  controlContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    rowGap: designTokens.spacing[3],
    width: "300px",
    gap: designTokens.spacing[3],
  },
  icon: {
    position: "absolute",
    right: designTokens.spacing[2],
  },
  loadStatisticsButton: {
    minWidth: "160px",
  },
  exportAndStatusContainer: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
  },
  loadingIndicator: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
  },
  chartsContainer: {
    width: "100%",
    backgroundColor: designTokens.neutral.white,
    ...shorthands.padding(designTokens.spacing[5]),
    ...shorthands.borderRadius(designTokens.borderRadius.lg),
    ...shorthands.border("1px", "solid", designTokens.neutral[200]),
    boxShadow: designTokens.shadow.sm,
    boxSizing: "border-box",
  },
  chartsRow: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[5],
    width: "100%",
    boxSizing: "border-box",
  },
  chartsRowWithTopPadding: {
    display: "flex",
    flexDirection: "column",
    paddingTop: designTokens.spacing[5],
    gap: designTokens.spacing[5],
    width: "100%",
    boxSizing: "border-box",
  },
  emptyChartsState: {
    minHeight: "280px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    color: designTokens.neutral[500],
    fontWeight: designTokens.fontWeight.medium,
  },
  downloadActiveUsers: {
    marginTop: designTokens.spacing[1],
  },
});

export const setGapBetweenHeadersAndDetailsList: IStackTokens = {
  childrenGap: designTokens.spacing[2],
  padding: 0,
};

// Keep these as exports for backward compatibility - will be removed after updating component
export const selectPeriodDropdownClassName = "";
export const cardContainerStyles = {};
export const cardStyles = {};
export const cardContentStyles = {};
export const controlContainerStyles = {};
export const iconStyles = {};
export const loadStatisticsButtonStyles = {};
export const exportAndStatusContainerStyles = {};
export const loadingIndicatorStyles = {};
export const chartsRowStyles = {};
export const chartsRowWithTopPaddingStyles = {};
